<template lang="pug">
el-dialog.vue-edit(fullscreen, :visible.sync="visible", @closed="onclosed", :close-on-click-modal="false")
  template(#title)
    span.el-dialog__title {{ title }}
      i.el-icon-info.tips(v-popover:popover)
      el-popover(ref="popover", placement="left-end", width="500", trigger="hover")
        .popover-title 自定义组件 - {{ fieldLabel }}
        dl
          dt 工具方法
          dd #[code axios] 发起请求
          dd #[code computedField(fieldKey)] 获取#[code fieldKey]的表单数据,支持双向绑定
          dt 实例属性/方法
          dd #[code this.fieldModel] 当前字段数据,支持双向绑定
          dd #[code this.vmDefaultValue] 默认值
          dd #[code this.rules] 当前字段表单规则
          dd #[code this.setWidgetValue(fieldKey,value)] 向表单#[code fieldKey]进行赋值
          dd #[code this.setValue(value)] 当前字段进行赋值
        a(href="https://www.yuque.com/u29330777/fwgv2x/cvkr8wtop6qqtdgk?singleDoc", target="_BLANK", rel="noopener noreferrer") 自定义组件文档
        dl
          dt 字段列表
          dd.grid-layout
            table.field-grid(border="1", cellpadding="2")
              tr
                th 字段
                th 字段名
              tr(v-for="{ label, name } in fieldList")
                td #[code {{ name }}]
                td {{ label }}

  codemirror(v-model="code", :options="cmOptions")
  template(#footer)
    el-button(@click="close()") 取消
    el-button(type="primary", @click="submit()") 保存
</template>
<script>
import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/juejin.css"; // juejin主题
import "codemirror/mode/vue/vue.js"; // 配置里面也需要mode设置为vue
import "codemirror/addon/selection/active-line"; // 光标行背景高亮，配置里面也需要styleActiveLine设置为true
import { asyncMixin } from "@/CommonDP/commons/asyncCom";
// import { subFormBus } from "../utils/panel-setting/subFormBus";
export default {
  components: { codemirror },
  mixins: [asyncMixin],
  data() {
    return {
      fieldList: [],
      visible: true,
      code: "",
      fieldKey: "",
      fieldLabel: "",
      title: "编辑代码",
      cmOptions: {
        tabSize: 4,
        mode: "vue-template",
        theme: "juejin",
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        matchBrackets: true, // 括号匹配
        lineWrapping: true,
        // 加提示
        hintOptions: {
          completeSingle: false
        }
      }
    };
  },
  methods: {
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    submit() {
      this.$emit("resolve", this.code);
      this.visible = false;
    },
    onclosed() {
      this.$emit("reject", this.code);
    },
    viewDocPage() {
      window.open("https://www.yuque.com/u29330777/fwgv2x/cvkr8wtop6qqtdgk?singleDoc", "_BLANK");
    }
  }
};
</script>
<style lang="scss" scoped>
.vue-edit {
  /deep/ .el-dialog {
    display: flex;
    flex-flow: column nowrap;
    .el-dialog__body {
      flex: 1 1;
      overflow: hidden;
    }
  }
}
.vue-codemirror {
  height: 100%;
  /deep/ .CodeMirror {
    border: 1px solid #eee;
    height: 100%;
  }
}
.el-link {
  margin-left: 24px;
}
.tips {
  margin-left: 1em;
}
dt {
  margin: 4px 0 0;
}
dd {
  margin: 2px 0 0;
}
code {
  background-color: #eee;
  padding: 0 3px;
  margin: 0 2px;
  box-shadow: 0 0 4px -1px #666;
}
.popover-title {
  font-size: 16px;
  margin: 0 0 8px 0;
  font-weight: bold;
}
.grid-layout {
  max-height: 500px;
  overflow: auto;
}
.field-grid {
  table-layout: fixed;
  width: 100%;
  border: 1px solid #333;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #333;
  }
}
</style>
